import React from 'react';
import PropTypes from 'prop-types';

import { ActionGroup as StyledActionGroup } from './styles';

const ActionGroup = ({ children, className, ...otherProps }) => {
    const classNames = ['item-actions', className].join(' ').trim();

    return (
        <StyledActionGroup className={classNames} {...otherProps}>
            {children}
        </StyledActionGroup>
    );
};

ActionGroup.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

export default ActionGroup;